import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _BellOffIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L4.58432 5.99853C4.09725 7.23173 3.94742 8.54072 3.91519 9.78658C3.896 10.5283 3.91846 11.2698 3.94438 11.9748L3.95594 12.284C3.97858 12.8838 4.00001 13.4516 4.00001 14C4.00001 15.1046 3.10458 16 2.00001 16C1.44772 16 1.00001 16.4477 1.00001 17C1.00001 17.5523 1.44772 18 2.00001 18H16.5858L22.2929 23.7071C22.6834 24.0976 23.3166 24.0976 23.7071 23.7071C24.0976 23.3166 24.0976 22.6834 23.7071 22.2929L17.7094 16.2952C17.7079 16.2937 17.7064 16.2921 17.7048 16.2906L6.50379 5.08957C6.49307 5.07834 6.48207 5.06734 6.47078 5.05657L1.70711 0.292893ZM6.17615 7.59037C6.00903 8.28471 5.93525 9.03692 5.91452 9.8383C5.89709 10.5121 5.91721 11.1992 5.94303 11.9014L5.9543 12.2022C5.97691 12.7999 6.00001 13.4105 6.00001 14C6.00001 14.7286 5.80522 15.4117 5.46488 16H14.5858L6.17615 7.59037Z"
        fill={iconColor}
      />
      <Path
        d="M9.05144 3.77092C10.9096 2.72242 13.1848 2.73955 15.0269 3.81591C16.8691 4.89227 18.0011 6.86592 18 8.99949V13C18 13.5523 18.4477 14 19 14C19.5523 14 20 13.5523 20 13V9.00051C20.0015 6.15576 18.4921 3.52422 16.0359 2.08907C13.5797 0.65393 10.5461 0.631087 8.06858 2.02908C7.58758 2.30049 7.41768 2.91043 7.68909 3.39143C7.9605 3.87242 8.57044 4.04233 9.05144 3.77092Z"
        fill={iconColor}
      />
      <Path
        d="M11.135 20.4982C10.8579 20.0205 10.246 19.8579 9.76824 20.135C9.29051 20.4121 9.12789 21.024 9.40501 21.5018C9.9417 22.427 10.9304 22.9965 12 22.9965C13.0696 22.9965 14.0583 22.427 14.595 21.5018C14.8721 21.024 14.7095 20.4121 14.2318 20.135C13.7541 19.8579 13.1421 20.0205 12.865 20.4982C12.6861 20.8066 12.3565 20.9965 12 20.9965C11.6435 20.9965 11.3139 20.8066 11.135 20.4982Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const BellOffIcon = assignWithoutSideEffects(_BellOffIcon, {
  componentId: 'BellOffIcon',
});

export default BellOffIcon;
